import React, { FC, useContext } from 'react';
import { PageNavItem } from './item/PageNavItem';
import { PageNavLayout } from './layout/PageNavLayout';
import { PageNavScrollHandler } from './scroll-handler/PageNavScrollHandler';
import { PageNavContext } from './PageNavContext';

export const PageNav: FC = () => {
  const { outline } = useContext(PageNavContext);
  return (
    <PageNavScrollHandler>
      <PageNavLayout>
        {outline.map((navItem) => (
          <PageNavItem key={navItem.id} navItem={navItem} />
        ))}
      </PageNavLayout>
    </PageNavScrollHandler>
  );
};
